import { render, staticRenderFns } from "./printsticker.vue?vue&type=template&id=1d05e4bf&"
import script from "./printsticker.vue?vue&type=script&lang=js&"
export * from "./printsticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports